<template>
  <div
    class="business-cards"
    :class="{ 'business-cards--multiple': companies.length > 1 }"
  >
    <BusinessCard
      v-for="(company, index) in companies"
      :key="company['display-name']"
      :company="company"
      :index="index"
    />
  </div>
</template>

<script>
import BusinessCard from 'chimera/all/page/thankYou/businessCard/BusinessCard.vue'

export default {
  name: 'BusinessCards',

  components: {
    BusinessCard,
  },

  props: {
    companies: {
      type: Array,
      required: true,
    },
  },
}
</script>
